var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBackMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretLeft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7075 25.2926C20.8004 25.3855 20.8741 25.4958 20.9244 25.6172C20.9747 25.7386 21.0006 25.8687 21.0006 26.0001C21.0006 26.1315 20.9747 26.2616 20.9244 26.383C20.8741 26.5044 20.8004 26.6147 20.7075 26.7076C20.6146 26.8005 20.5043 26.8742 20.3829 26.9245C20.2615 26.9747 20.1314 27.0006 20 27.0006C19.8686 27.0006 19.7385 26.9747 19.6171 26.9245C19.4957 26.8742 19.3854 26.8005 19.2925 26.7076L9.29249 16.7076C9.19952 16.6147 9.12576 16.5044 9.07543 16.383C9.02511 16.2616 8.99921 16.1315 8.99921 16.0001C8.99921 15.8687 9.02511 15.7385 9.07543 15.6171C9.12576 15.4957 9.19952 15.3854 9.29249 15.2926L19.2925 5.29257C19.4801 5.10493 19.7346 4.99951 20 4.99951C20.2654 4.99951 20.5199 5.10493 20.7075 5.29257C20.8951 5.48021 21.0006 5.7347 21.0006 6.00007C21.0006 6.26543 20.8951 6.51993 20.7075 6.70757L11.4137 16.0001L20.7075 25.2926Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBackMobile);
export default __webpack_public_path__ + "static/media/icons-back-mobile.347c5fb2a0114f4a5fee2629aae39226.svg";
export { ForwardRef as ReactComponent };